import { render, staticRenderFns } from "./BaseModalConfirmation.vue?vue&type=template&id=c5b37830&"
import script from "./BaseModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports